/* Defaults shared by index.html's static tags and the per-page meta set at runtime; keep the two in sync */
export const SITE_URL = "https://version3.ai";
export const SITE_NAME = "Version3 AI";
export const DEFAULT_DESCRIPTION =
  "Version3 is a software company building AI agents, automation and custom software around how your business actually runs, from first idea to scale.";
export const OG_IMAGE = `${SITE_URL}/assets/images/og-image.png`;
